<template>
  <div class="guide__content--wrap">
    <a v-if="guideUrl"
      class="btn__pdf-download" :href="guideUrl" target="_blank" download="download">
      <span>{{ $t('page.registration.guide.download') }}</span>
    </a>
    <div class="step1__guide--wrap" v-if="currentStep === 1">
      <Guide1 :focusContent="pageAddGuideFocusContent"/>
    </div>

    <div class="step2__guide--wrap" v-if="currentStep === 2">
      <Guide2 :focusContent="pageAddGuideFocusContent"/>
    </div>

    <div class="step3__guide--wrap" v-if="currentStep === 3">
      <Guide3 :focusContent="pageAddGuideFocusContent"/>
    </div>

    <div class="step4__guide--wrap" v-if="currentStep === 4">
      <Guide4 :focusContent="pageAddGuideFocusContent"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Guide1 from '@/components/page-registration/Guide1'
import Guide2 from '@/components/page-registration/Guide2'
import Guide3 from '@/components/page-registration/Guide3'
import Guide4 from '@/components/page-registration/Guide4'

export default {
  components: {
    Guide1,
    Guide2,
    Guide3,
    Guide4
  },
  props: [
    'currentStep'
  ],
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    ...mapState([
      'pageAddGuideFocusContent'
    ]),
    guideUrl () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://dream-cdn.beusable.net/dream/files/pdf/%5BRegistration%5D_%EB%B7%B0%EC%A0%80%EB%B8%94_%ED%8E%98%EC%9D%B4%EC%A7%80+%EB%93%B1%EB%A1%9D+%EA%B0%80%EC%9D%B4%EB%93%9C_20200317(ko).pdf '
        case 'en':
          return 'https://dream-cdn.beusable.net/dream/files/pdf/[Registration]_Beusable%20Page%20Registration%20Guide_20200317(en).pdf'
        case 'ja':
          return null
          // return 'https://dream-cdn.beusable.net/dream/files/pdf/[Registration]_%E3%83%93%E3%83%A5%E3%83%BC%E3%82%B6%E3%83%96%E3%83%AB%E3%81%AE%E3%83%9A%E3%83%BC%E3%82%B8%E7%99%BB%E9%8C%B2%E3%82%AC%E3%82%A4%E3%83%89_20191111(ja).pdf'
        default:
          return null
      }
    }
  }
}
</script>

<style lang="scss">
.guide__content--wrap {
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  overflow: auto;
  display: flex;
  flex-direction: column;

  & > div {
    height: 100%;
    margin-top: 80px;
  }
  .btn__pdf-download {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 2;

    i {
      @include positionYcenter;
      left: -23px;
    }
    span {
      font-size: 13px;
      font-weight: bold;
      line-height: 1;
      color: #ffffff;
    }
  }
  .swiper-container {
    width: 100%;
    overflow: hidden;

    margin: 0 auto;
    position: relative;
    list-style: none;
    padding: 0;
    z-index: 1;

    .swiper-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      transition-property: transform;
      box-sizing: content-box;

      .swiper-slide {
        position: relative;
        ms-flex-negative: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        transition-property: transform;

        display: flex;
        justify-content: center;
        align-items: center;

        padding-left: 40px;
        padding-right: 40px;
        box-sizing: border-box;

        .swiper-content--wrap {
          height: 380px;
          padding: 10px 0px;

          .img--wrap {
            margin-left: auto;
            margin-right: auto;
            background-size: contain;
            background-repeat: no-repeat;
          }
          .desc--wrap {
            .title {
              font-size: 15px;
              line-height: 1;
              color: #ebebeb;
            }
            ul {
              margin-top: 20px;

              .desc {
                font-size: 13px;
                line-height: 1.46;
                color: #d7d7d7;
                margin-top: 10px;

                strong {
                  color: #ffd100;
                }
              }
            }
          }
        }
      }
    }

    .swiper-pagination {
      width: 100%;
      left: 0;
      bottom: 10px;

      position: absolute;
      text-align: center;
      transition: opacity .3s;
      transform: translateZ(0);
      z-index: 10;

      .swiper-pagination-bullet {
        margin: 0 4px;
        width: 8px;
        height: 8px;
        display: inline-block;
        border-radius: 100%;
        background-color: #666666;
        cursor: pointer;

        &.swiper-pagination-bullet-active {
          background-color: #ffffff;
        }
      }
    }
    .swiper-button-next, .swiper-button-prev {
      top: 50%;
      margin-top: -22px;
      z-index: 10;
      cursor: pointer;
      padding: 10px;
      background-position: center;
      @include positionYcenter;
    }
    .swiper-button-prev {
      left: 0px;
      right: auto;
    }
    .swiper-button-next {
      right: 0px;
      left: auto;
      transform: rotate(180deg) translateY(50%);
    }
  }

  .step1__guide--wrap {
    .list1,
    .list2,
    .list3,
    .list4,
    .list5,
    .list6 {
      .img--wrap { background-image: url(../../assets/img/page/regi_guide_2.png); width: 400px; height: 151px;  margin-top: -5px;  margin-bottom: 47px; }
    }
    .list7 {
      &.ko {
        .img--wrap { background-image: url(../../assets/img/page/regi_guide_2-7_ko.png); width: 380px; height: 126px; margin-top: 56px; }
      }
      &.ja {
        .img--wrap { background-image: url(../../assets/img/page/regi_guide_2-7_ja.png); width: 380px; height: 126px; margin-top: 56px; }
      }
      &.en {
        .img--wrap { background-image: url(../../assets/img/page/regi_guide_2-7_en.png); width: 380px; height: 126px; margin-top: 56px; }
      }
      .figcaption {
        display: block;
        margin: 0 auto;
        width: 100%;
        font-size: 12px;
        font-weight: bold;
        color: #d7d7d7;
        white-space: nowrap;

        span {
          display: inline-block;
          width: 100px;
          text-align: center;
          line-height: 1.4;
          &.first-text {
            margin-right: 40px;
          }
          &.second-text {
            margin-right: 40px;
          }
          &.third-text {
            color: #ffd100;
          }
        }
      }
    }
    .list8 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_2-8_ko.png); width: 400px; height: 151px;  margin-bottom: 43px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_2-8_ja.png); width: 400px; height: 151px;  margin-bottom: 43px;  }
        .swiper-content--wrap .desc--wrap ul .desc.bLogin {
          margin-top: 0px;
        }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_2-8_en.png); width: 400px; height: 151px;  margin-bottom: 43px;  }
      }
    }
    .list9 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_2-9_ko.png); width: 400px; height: 151px;  margin-bottom: 43px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_2-9_ja.png); width: 400px; height: 151px;  margin-bottom: 43px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_2-9_en.png); width: 400px; height: 151px;  margin-bottom: 43px;  }
      }
    }
  }
  .step2__guide--wrap {
    .list1 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-1_ko.png); width: 336px; height: 168px;  margin-top: 6px;  margin-bottom: 21px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-1_ja.png); width: 336px; height: 168px;  margin-top: 6px;  margin-bottom: 21px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-1_en.png); width: 336px; height: 168px;  margin-top: 6px;  margin-bottom: 21px;  }
      }
    }
    .list2 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-2_ko.png); width: 316px; height: 119px;  margin-top: 29px;  margin-bottom: 47px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-2_ja.png); width: 316px; height: 119px;  margin-top: 29px;  margin-bottom: 47px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-2_en.png); width: 316px; height: 119px;  margin-top: 29px;  margin-bottom: 47px;  }
      }
    }
  }
  .step3__guide--wrap {
    .list1 {
      .desc--wrap {  margin-top: 90px;  }
    }
    .list2 {
      .desc--wrap {  margin-top: 90px;  }
    }
    .list3 {
      .text-ex {  margin-top: 17px;   font-size: 13px;  line-height: 1.46;  color: #aaaaaa;  }
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_3-3_ko.png);  width: 342px; height: 100px;  margin-top: 10px;  margin-bottom: 38px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_3-3_ja.png);  width: 342px; height: 100px;  margin-top: 10px;  margin-bottom: 38px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_3-3_en.png);  width: 342px; height: 100px;  margin-top: 10px;  margin-bottom: 38px;  }
      }
    }
  }
  .step4__guide--wrap {
    .list1 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_4-1_ko.png);  width: 210px;  height: 168px;  margin-bottom: 26px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_4-1_ja.png);  width: 210px;  height: 168px;  margin-bottom: 26px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_4-1_en.png);  width: 210px;  height: 168px;  margin-bottom: 26px;  }
      }
    }
    .list2, .list3 {
      .img--wrap {
        @include flexXbetween;
        .icon {
          margin-top: 40px;
        }
      }
      figcaption {
        margin-top: 12px;
      }
      .figure-caption {
        margin-top: 18px;
      }
      figcaption, .figure-caption {
        text-align: center;
        font-size: 13px;
        line-height: 1.46;
        color: #aaaaaa;

        strong {
          color: #ffd100;
        }
      }
      .desc--wrap {
        margin-top: 40px;
      }
    }
  }
}
</style>
